import { FieldTypeAsset, FieldTypeLink } from '@allesauto/utils/consts';
import {
  getUrlFromStoryblokLink,
  parseSlashToURL,
} from '@allesauto/utils/funcs';
import { ArrowRight32 } from '@carbon/icons-react';
import clsx from 'clsx';
import React from 'react';

import NextImage from '../../nextImage';
import NextLink from '../../nextLink';

export interface ArticleProps {
  headline: string;
  content: string;
  image?: FieldTypeAsset;
  link?: FieldTypeLink;
}

const Article: React.FC<ArticleProps> = (props) => {
  const { headline, content, image, link } = props;

  const linkUrl = link && getUrlFromStoryblokLink(link);
  const isArticleClickable = linkUrl ? true : false;

  const className = {
    wrapper: clsx(
      'group py-30px relative lg:p-60px',
      isArticleClickable && 'lg:hover:bg-grey10 lg:pb-[90px]'
    ),
    image: 'relative mb-30px aspect-[16/10]',
    headline: clsx(
      'font-headline mb-20px text-headline4',
      isArticleClickable && 'text-purple80',
      !isArticleClickable && 'text-grey100'
    ),
    content: 'text-grey80 text-p1 font-regular',
    border:
      'bg-green60 absolute bottom-0 duration-100 scale-y-0 group-hover:lg:scale-y-100 origin-bottom ease-linear h-7px left-0 overflow-hidden transition-all w-full z-10',
    arrow:
      'absolute hidden group-hover:lg:block right-60px bottom-35px text-purple80',
    link: 'no-underline before:block before:absolute before:z-10 before:left-0 before:top-0 before:w-full before:h-full',
  };

  return (
    <div className={className.wrapper}>
      {image?.filename && (
        <div className={className.image}>
          <NextImage
            useCustomLoader={false}
            layout="fill"
            src={image.filename}
            alt={image.alt}
            objectFit="cover"
          />
        </div>
      )}
      {linkUrl ? (
        <NextLink
          href={parseSlashToURL(linkUrl)}
          target={link.target ?? '_self'}
          className={className.link}
        >
          <h2 className={className.headline}>{headline}</h2>
        </NextLink>
      ) : (
        <h2 className={className.headline}>{headline}</h2>
      )}
      <div className={className.content}>{content}</div>
      {isArticleClickable && (
        <>
          <div className={className.border}></div>
          <span className={className.arrow}>
            <ArrowRight32 />
          </span>
        </>
      )}
    </div>
  );
};

export default Article;
